import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface NameSearchState {
  messageError: any
  searchResults: any[]
  nameFileUpload: any
}

export const useNameSearchStore = defineStore('nameSearch', {
  state: (): NameSearchState => ({
    messageError: null,
    searchResults: [],
    nameFileUpload: null,
  }),

  getters: {
    getSearchResults: (state) => state.searchResults,
    getNameFileUpload: (state) => state.nameFileUpload,
    getMessageError: (state) => state.messageError,
  },

  actions: {
    async uploadBusinessNames(data: any) {
      try {
        const response = await api().post('/namesearch/upload-names-file', data)
        this.searchResults = response.data
      } catch (error: any) {
        this.messageError = error.response?.data
      }
    },

    async doSearch(filters: string) {
      try {
        const response = await api().get('/namesearch/search' + filters)
        this.searchResults = response.data
      } catch (error: any) {
        this.messageError = error.response?.data
      }
    },

    async doGetFilters() {
      try {
        const response = await api().get('/namesearch/filters')
        // Note: Original mutations set filters and message, but state didn't have these properties
        // Keeping the same behavior (response received but not stored)
      } catch (error: any) {
        this.messageError = error.response?.data
      }
    },
  },
})
